import React, {
    useContext,
    useEffect,
    useState
} from 'react';
import { useMutation } from '@tanstack/react-query';

import { NotificationContext, handleError } from '../context/NotificationContext';

import * as QUERIES from "../queries/query-functions";
import config from '../config/config';
import * as UTILS from "../utils/utils";

import LoadingIndicator from '../components/loading-indicator';
import { getBasketData, refetchBasketData } from "../queries/global";
import useTimedMessage from '../hook/useTimedMessage';

const ticketProtectionMessage = config.OPTION_FIELDS.ticket_protection_message?.innerHTML ?? null;

export default function TicketInsurance(props) {
    const { data: basketData, isFetching: basketDataFetching } = getBasketData();
    const {notification, setNotification} = useContext(NotificationContext);
    const { message: successMessage, setMessage: setSuccessMessage, fadeOut } = useTimedMessage(5000);

    const [ticketQuantity, setTicketQuantity] = useState(1);
    const [isPurched, setIsPurched] = useState(false);
    const price = props.instance?.priceList?.prices ? props.instance.priceList.prices[0] : null;


    const addTickets = useMutation({
        mutationFn: () => QUERIES.addTickets(ticketQuantity, price.ticketType.id, "", props.instance.id, props.instance.planId),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: () => {
            setIsPurched(true);
            props.setIsInBasket(true);
            setSuccessMessage("Insurance is added to basket.")
            refetchBasketData();
        },
    });

    useEffect(() => {
        if (!basketData) return;

        let tickets = UTILS.getTicketsByInstance(basketData.tickets);
        setTicketQuantity(tickets.length);

        let protection = UTILS.getTicketsByInstance(basketData.tickets, props.instance.id);
console.log("protection", props.instance.id)
        
        setIsPurched(protection.length > 0)
    
    }, [basketData])

    if (props.isAccountPage && props.instance.event.attribute_ExcludeFromAccountUpsell === true) {
        return null;
    }

    return (
        <section className='prompt prompt--ticket-insurance'>
            <header className='prompt__header'>
                <h2 className='prompt__title'>{props.sectionTitle || 'Ticket Refund Protection'}</h2>
                { !!price && (
                        <p className='prompt__price'>
                            { price.amount === 0
                                ? 'Free'
                                : `£${ price.amount.toFixed(2) } per ticket`
                            }
                        </p>
                    )}
            </header>
            {
                ticketProtectionMessage ?
                    <div className='prompt__content' dangerouslySetInnerHTML={{__html: ticketProtectionMessage}}></div>
                    // :props.instance.event?.htmlDescription ?
                    //     <div className='prompt__content' dangerouslySetInnerHTML={{__html: props.instance.event.htmlDescription}}></div>
                    //     : props.instance.event?.description ?
                    //         <div className='prompt__content'>{ props.instance.event.description }</div>
                    :null
                }
            <div className='prompt__button'>
                {!isPurched ?
                    <button className='btn btn--primary' 
                        type="button" 
                        onClick={() => { 
                            addTickets.mutateAsync(); 
                            // setSuccessMessage(null)
                        }}
                        disabled={addTickets.isPending}>
                        Add to basket
                        {addTickets.isPending &&
                            <LoadingIndicator />
                        }
                    </button>
                    :<p className='btn btn--purple-neutral100'>Added to basket</p>
                }
                <p className='prompt__button-text'>Applies to all tickets selected for this event.</p>
                {/* {successMessage &&
                    <p className={`confirmation-message ${fadeOut ? "fade-out" : ""}`}>{successMessage}</p>
                } */}
            </div>
        </section>
    );
}